import "./WhatsappChat.css";
import doctor from "../../assets/img/avatars/doctor.png";
import bot from "../../assets/img/avatars/bot.png";
import woman from "../../assets/img/avatars/woman.png";
import { MdInfo } from "react-icons/md";

interface QnaMsgBody {
  type?: string;
  content?: string;
  heading?: string;
  items?: string[];
}

interface QnaMessage {
  msg: QnaMsgBody;
  sender_type?: string;
  sender_name?: string;
  user_name?: string;
  date: string | number;
}

interface ChatBubbleProps {
  msg: QnaMessage;
}

/*
 * Clinic-OS bubbles. Colour = meaning: the customer is neutral clinic grey, our
 * side (doctor/bot) is a single quiet action-teal tint — no blue-vs-teal-vs-green
 * guessing. Timestamps are tabular meta that recedes.
 */
const OUR_BUBBLE =
  "my-4 rounded-t-md rounded-bl-md bg-action-50 p-3.5 text-[13.5px] leading-snug text-clinic-900 ring-1 ring-action-100";

function Stamp({ date }: { date: string | number }) {
  const timeOptions: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const dateOptions: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "short",
    year: "numeric",
  };
  return (
    <div className="mt-1 flex items-center justify-end gap-x-1 text-[10px] tabular-nums text-clinic-500">
      <p>{new Date(date).toLocaleDateString("en-gb", dateOptions)}</p>
      <p>{new Date(date).toLocaleTimeString("en-gb", timeOptions)}</p>
    </div>
  );
}

function ChatBubble({ msg }: ChatBubbleProps) {
  return (
    <div>
      {((msg?.msg?.type === "text" || msg?.msg?.type === "media") &&
        msg?.sender_type === "bot") ||
      msg?.sender_type === "doctor" ? (
        <div className="flex justify-end gap-x-1">
          <div className={`message-main-sender flex flex-col ${OUR_BUBBLE}`}>
            {msg?.sender_type === "doctor" && (
              <span className="mb-0.5 text-center font-mono text-[9px] font-semibold uppercase tracking-[0.12em] text-action-700">
                {msg?.sender_name}
              </span>
            )}
            {msg?.msg.type === "media" ? (
              <span className="flex items-center justify-center gap-x-2 font-medium text-warn-600">
                Media Sent <MdInfo aria-hidden="true" />
              </span>
            ) : (
              msg?.msg?.content
            )}
            <Stamp date={msg?.date} />
          </div>
          {msg?.sender_type === "doctor" && (
            <img src={doctor} alt="" className="mb-4 h-6 w-6 self-end" />
          )}
          {msg?.sender_type === "bot" && (
            <img src={bot} alt="" className="mb-4 h-6 w-6 self-end" />
          )}
        </div>
      ) : (msg?.msg?.type === "list" && msg?.sender_type === "bot") ||
        msg?.sender_type === "doctor" ? (
        <div className="flex justify-end gap-x-1">
          <div className={`message-main-sender flex-col ${OUR_BUBBLE}`}>
            <h3 className="text-center font-semibold underline">
              {msg?.msg?.heading}
            </h3>
            <ul>
              {msg?.msg?.items?.map((item, i) => (
                <li className="list-disc" key={i}>
                  {item}
                </li>
              ))}
            </ul>
            <Stamp date={msg?.date} />
          </div>
          <img src={bot} alt="" className="mb-4 h-6 w-6 self-end" />
        </div>
      ) : msg?.sender_type === "customer" ? (
        <div className="flex justify-start gap-x-1">
          <img src={woman} alt="" className="mb-4 mt-4 h-6 w-6 self-start" />
          <div className="message-main-receiver my-4 w-max rounded-b-md rounded-tr-md bg-clinic-100 p-3.5 text-[13.5px] leading-snug text-clinic-900">
            <div className="flex flex-col">
              {msg?.user_name && (
                <span className="mb-0.5 font-mono text-[9px] font-semibold uppercase tracking-[0.12em] text-clinic-500">
                  ~ {msg?.user_name}
                </span>
              )}
              {msg?.msg.type === "media" ? (
                <span className="flex items-center justify-center gap-x-2 font-medium text-warn-600">
                  Media Recieved <MdInfo aria-hidden="true" />
                </span>
              ) : (
                msg?.msg?.content
              )}
            </div>
            <Stamp date={msg?.date} />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ChatBubble;
